import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import Scene360Hotspot from '../360_react/Scene360Hotspot';
import Urls from '../urls/Urls';
import EulerAngles from '../geometry/EulerAngles';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class HotspotOutside360Info extends Scene360Hotspot{
	constructor(props){
		super(props);
		this._rotateToCompensate = false;
		const {text, className, iconRelativePath}=props;
		if(text===undefined||text===null)
			throwNotProvided('text');
		this._text=text;
		if(className===undefined||className===null)
			throwNotProvided('className');
		this._className=className;
	}
	get fromFactory(){
		return true;
	}
	get className(){
		return this._className;
	}
	get text(){
		return this._text;
	}
	static fromJSON(jObject){
		return new HotspotOutside360Info({
			iconRelativePath:jObject.iconRelativePath,
			type:jObject.type,
			eulerAngles:EulerAngles.fromJSON(jObject.eulerAngles)
		});
	}
}